import { OnChangeParams } from 'baseui/select';
import { useMemo, useState } from 'react';
import { useRecoilValue } from 'recoil';
import { deviceCarriersState } from '../../../storage/devices';
import { DeviceCarrier } from '../../../types/deviceCarrier';
import EnhancedLabeledSelect from '../../ui/EnhancedLabeledSelect';

type Props = {
  deviceCarrier?: DeviceCarrier;
  selectedDeviceCarrierSlug?: string;
  onChangeDeviceCarrier: (deviceCarrierSlug?: string) => void;
  isFilter?: boolean;
  label?: string;
  inline?: boolean;
  required?: boolean;
};
export function DeviceCarrierSelect({
  selectedDeviceCarrierSlug,
  onChangeDeviceCarrier,
  deviceCarrier,
  isFilter = true,
  label = 'Carrier:',
  inline = false,
  required = false,
}: Readonly<Props>) {
  const devicesCarriersList = useRecoilValue(deviceCarriersState);
  const [selectedDeviceCarrierOption, setSelectedDeviceCarrierOption] = useState<{ id: string; label: string }>();

  const deviceCarrierOptions = useMemo(() => {
    if (!devicesCarriersList) return;
    const devicesCarriersOptions: { id: string | undefined; label: string }[] = devicesCarriersList.map(
      (deviceCarrier) => ({
        id: deviceCarrier.slug,
        label: deviceCarrier.label,
      })
    );
    if (!required) {
      devicesCarriersOptions?.unshift({
        id: undefined,
        label: isFilter ? 'Todos' : 'Ninguno',
      });
    }
    if (deviceCarrier) {
      if (!devicesCarriersOptions.find((c) => c.id === deviceCarrier.slug))
        devicesCarriersOptions.push({
          id: deviceCarrier.slug,
          label: deviceCarrier.label,
        });
    }
    if (selectedDeviceCarrierOption) {
      if (!devicesCarriersOptions.find((c) => c.id === selectedDeviceCarrierOption.id))
        devicesCarriersOptions.push(selectedDeviceCarrierOption);
    }
    return devicesCarriersOptions;
  }, [devicesCarriersList]);

  const onDeviceCarrierChange = (params: OnChangeParams) => {
    params.option?.id ? onChangeDeviceCarrier(params.option.id as string) : onChangeDeviceCarrier(undefined);
    setSelectedDeviceCarrierOption(params.option as { id: string; label: string });
  };

  return (
    <EnhancedLabeledSelect
      label={label}
      options={deviceCarrierOptions}
      value={selectedDeviceCarrierSlug ? [{ id: selectedDeviceCarrierSlug }] : undefined}
      onChange={onDeviceCarrierChange}
      fullWidth
      inline={inline}
      inset={inline}
      required={required}
    />
  );
}
